import { UserProperty } from "../redux/reducers/getPropertySelectionListReducer/propertySelectionListReducer";

export const filterPropertyList = (arr: UserProperty[], searchTerm: string) => {
    return arr.filter((value) => {
        if (searchTerm !== "") {
            const rollNum = value.roll_num as string;
            const address = value.address as string;
            const city = value.city as string;
            if (typeof address == "string" && typeof city == "string") {
                if (address.toLowerCase().includes(searchTerm.toLowerCase()) || city.toLowerCase().includes(searchTerm.toLowerCase())) {
                    return value;
                }
            }
            if (rollNum.includes(searchTerm)) {
                return value;
            }

            return null;
        }
        return value
    })
}